// Lightweight Supabase client for contact form only
// This reduces bundle size by only importing what we need

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://fdvcnbruddgrdnmbpsqc.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZkdmNuYnJ1ZGRncmRubWJwc3FjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDczOTgwMjEsImV4cCI6MjA2Mjk3NDAyMX0.o09FO3uuveUTZD5l91gek2bGSlyRAXOlZTnZzUp2Y6E'

// Create lightweight client with minimal features
export const supabaseLite = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false, // Disable auth persistence for contact form
    autoRefreshToken: false, // Disable auto refresh for contact form
  },
  realtime: {
    params: {
      eventsPerSecond: -1 // Disable realtime
    }
  }
})

// Export a function to get the full client when needed (lazy loading)
export const getFullSupabaseClient = async () => {
  const { supabase } = await import('@/integrations/supabase/client')
  return supabase
}